module.exports = __webpack_public_path__ + "e923ff5a50c45bb264524cc1bd2917f7.png";